export enum BackButtonBlockerId {
  DirtyRouteContext = 'dirty-route-context',
  // Dispatched directly from apps/ember-webapp/app/mixins/dirty-route.js (plain string there,
  // kept in sync manually - that file can't import this TS enum).
  EmberDirtyRoute = 'ember-dirty-route',
}
